export default {
  apiKey: process.env.REACT_APP_API_KEY,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  projectId: process.env.REACT_APP_PROJECT_ID,
  appId: process.env.REACT_APP_APP_ID,
  senderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_STRING,
  databaseURL: process.env.REACT_APP_DATA_BASE_URL,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
}
